import { action, computed, makeAutoObservable, runInAction } from "mobx";
import moment from "moment";
import { Api } from "../../../common/Api";
import { FilterStore } from "../../FilterStore";
import { ArticleEditStore } from "./ArticleEditStore";
import { ArticlePublishStore } from "./ArticlePublishStore";

export class ArticlesStore {
  filterStore: FilterStore;
  editStore: ArticleEditStore;
  publishStore: ArticlePublishStore;

  loading = false;

  filter: any = {
    page: 0,
    size: 100,
    retired: false,
    keyword: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "updatedAt", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new FilterStore(this);
    this.editStore = new ArticleEditStore(this);
    this.publishStore = new ArticlePublishStore(this);

    this.filterStore.notReset = ["retired"];
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);

    // let period: string[] = [];
    // if (this.filter.period?.[0]) {
    //   period = [
    //     moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
    //     moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
    //   ];
    // }
    // const query = new URLSearchParams({ ...this.filter, period, page: 0 });
    // history.push({ search: query.toString() });
  }

  @action onPage(history, page, size) {
    let period: any[] = [undefined, undefined];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);

    const retired = params.get("retired") === "true";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");
    const keyword = params.get("keyword") || "";

    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    this.filter = { retired, keyword, period, page, size };

    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { retired, period, keyword, page, size } = this.filter;
    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];
    const filter: any = { retired, keyword, page, size, sorts };

    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    return Api.content.article
      .articles(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.articles;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }
}

export const articlesStore = new ArticlesStore();
